import React, {FC} from 'react';
import {Result} from 'antd';
import styles from './MaintenanceScreen.module.less';

const MAINTENANCE_MESSAGE =
    'We are currently undergoing planned maintenance as part of our platform migration. ' +
    'This downtime was scheduled in advance and our team is actively working to complete the transition.';

const MaintenanceScreen: FC = () => {
    return (
        <div className={styles.container}>
            <Result status="warning" title="Scheduled Maintenance" subTitle={MAINTENANCE_MESSAGE} />
        </div>
    );
};

export default MaintenanceScreen;
